import { render, staticRenderFns } from "./OnePageReturn.vue?vue&type=template&id=221c0b88&scoped=true&"
import script from "./OnePageReturn.vue?vue&type=script&lang=js&"
export * from "./OnePageReturn.vue?vue&type=script&lang=js&"
import style0 from "./OnePageReturn.vue?vue&type=style&index=0&id=221c0b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c0b88",
  null
  
)

export default component.exports